module.exports = __webpack_public_path__ + "img/login-ciudadelamexico.5b644a3f.svg";